import React, {useContext} from 'react';
import SummaryContext from '../../../contexts/SummaryContext';
import SummaryContent from './SummaryContent';
import style from './Summary.scss';

const Summary = () => {
  const {
    summary: {totalActiveGiftsRequested = 0, totalCashFunds = 0},
  } = useContext(SummaryContext);
  const hasRegisteredForGifts = totalActiveGiftsRequested > 0;
  const hasRegisteredForCashFunds = totalCashFunds > 0;

  return (
    <section className={style.summary} data-testid="overview-summary">
      <SummaryContent
        hasRegisteredForGifts={hasRegisteredForGifts}
        hasRegisteredForCashFunds={hasRegisteredForCashFunds}
      />
    </section>
  );
};

export default Summary;
